import React from 'react';

export const SuccessSvg = () => {
  return (
    <svg width="273" height="130" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(73)">
          <path
            fill="#2B518E"
            d="M77.785 129.64l-13.893-13.801L50 129.639V86h27.785z"
          ></path>
          <path
            d="M113.947 0L73.734 69.65l.75 1.298L63.82 89.462l-.762-1.32-.762 1.32-10.665-18.511.75-1.302L12.17.001l21.354.001 29.534 51.156L92.594 0h21.353z"
            fill="#FFF"
          ></path>
          <circle fill="#E0EBEF" cx="64" cy="79" r="27"></circle>
          <circle
            stroke="#1A3B71"
            strokeWidth="2"
            strokeLinecap="round"
            cx="64"
            cy="79"
            r="22.5"
          ></circle>
          <path
            d="M118 81h10M0 81h10M110 106l9 5M9 47l9 5M110 52l9-5M9 111l9-5"
            stroke="#CFC5C0"
            strokeWidth="1.5"
            strokeLinecap="round"
          ></path>
        </g>
        <path
          fill="#1A3B71"
          fillRule="nonzero"
          d="M136.022 72.166h-3.39l1.626-2.768h4.722V89h-2.958z"
        ></path>
      </g>
    </svg>
  );
};
